import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class FeedbackToSlackText extends PrimitiveValueObject<string> {
  static create(value: string): FeedbackToSlackText {
    // if (value === null) {
    //   throw new ArgumentNullException();
    // }
    return new FeedbackToSlackText(value);
  }
}
